import { createElementFromHTML } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';
import './dynamic-loader.scss';

class DynamicLoader {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-dynamicloader',
            routeAttr: 'data-dynamicloader-route',
            triggerValue: 'trigger'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$trigger = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.triggerValue}"]`);

        // Properties
        this.route = this.$root.getAttribute(this.settings.routeAttr);
        this.currentPage = 1;
    }

    initialize () {
        this.setEvents();
    }

    loadData() {
        new AjaxLoad(this.route, {  
            onSuccess: (result) => {
                const $markup = createElementFromHTML(result);
                const $liveRegion = this.$root.parentNode.querySelector('[aria-live]');

                if ($markup) {
                    const contentUpdateEvent = new CustomEvent('content.loaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: $markup
                        }
                    });

                    window.dispatchEvent(contentUpdateEvent);

                    const children = Array.from($markup.childNodes);

                    children.forEach(child => {
                        this.$root.parentNode.insertBefore(child, this.$root);
                    });

                    if ($liveRegion) {
                        const text = $liveRegion.getAttribute(this.settings.initAttr);
                        const count = $liveRegion.parentNode.querySelectorAll('li').length;

                        if (text !== null) {
                            $liveRegion.textContent = text.replace('%count%', count);
                        }
                    }

                    this.$root.remove();
                }
            }
        });
    }

    setEvents () {
        if (this.$trigger && this.route !== null) {
            this.$trigger.addEventListener('click', () => {
                this.loadData();
            });
        }
    }
}

export { DynamicLoader };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-dynamicloader="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new DynamicLoader($root);
            $rootAPI.initialize();
        });
    }
});
